import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { PaymentsConfig } from 'containers/forms/payments'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Registrations',
  intlKey: 'pageTitle.registrations',
  dynamicProp: 'organizations.detail.name'
})
@withRouter
class AwardUnitPayments extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired
  }

  static defaultProps = {
    params: {}
  }

  render() {
    const { params } = this.props

    return <PaymentsConfig decoOrganizationId={params.id} {...this.props} />
  }
}

export default AwardUnitPayments
